export const getSortListContainerStyle = (theme) => ({
    maxWidth: '24rem',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 'calc(100% - 1.5rem)',
});